import { TMATTCourseOptions } from './../types/index'
import { authorizedAction } from 'api'
import { ErrorProp } from './'

export type EnrollTMATTResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type EnrollTMATTProps = {
  userId?: string
  course: TMATTCourseOptions['course']
}

export async function enrollTMATT({
  userId,
  course,
}: EnrollTMATTProps): Promise<EnrollTMATTResponseProps> {
  try {
    if (course !== 'tmatt' && course !== 'tmatt-refresher') {
      throw new Error('Invalid course')
    }
    const action =
      course === 'tmatt'
        ? 'Teacher.EnrollToLMSCourse'
        : 'Teacher.EnrollToRefresherCourse'

    const response = await authorizedAction({
      action: action,
      body: {
        Username: userId,
      },
    })
    const json = (await response.json()) as EnrollTMATTResponseProps
    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
